import { FC } from 'react';
import './App.css';
import Layout from './components/layout/Layout';
import Main from './pages/main/Main';
import RequestSuccess from './pages/request-success/RequestSuccess';
import { JurisdictionContextProvider } from './contexts/jurisdiction-context';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from 'react-router-dom';

const App: FC = () => {
    
    return (
        <Router>
            <JurisdictionContextProvider>
                <Layout>
                    <div className="rounded-sm _bg-white my-4 sm:my-6 lg:my-8 theme-page">
                        <Switch>
                            <Route exact path={`/public/request/:slug`}>
                                <Main />
                            </Route>
                            <Route path={`/public/request/:slug/success`}>
                                <RequestSuccess />
                            </Route>
                        </Switch>
                    </div>
                </Layout>
            </JurisdictionContextProvider>
        </Router>
    );
}

export default App;
